
import React, { useEffect, useState } from 'react';
import { List, NavBar } from 'antd-mobile'

import { 
    BodyView,
    ListView
} from "../factory/ViewUtil";
import { CellStateView } from '../factory/CellViews';
import { FeedbackResortList } from '../../NetworkFactory';
import { FullURL, ToDate1 } from '../factory/FactoryUtil';

const ItemView = React.memo(({item, onClick, onPreview}) => {
    const imgsrc = item.img
    return (
        <List.Item onClick={onClick} arrowIcon={false} className='cellCardBorder'>
            <div style={{display : 'flex', marginBottom : '10px'}}>
                <div style={{flex : '1'}}>{item.title}</div>
                <div style={{marginLeft : '6px', fontSize : '14px', color : "#666"}}>{ToDate1(item.creationDate)}</div>
            </div>
            <div>{item.message}</div>
            <div>
                {
                    imgsrc === undefined ? '' : <img alt='' onClick={onPreview} width={100} height={100} src={FullURL(imgsrc)} style={{objectFit : 'contain', background : '#eee', marginTop : '10px', borderRadius : '8px'}}/>
                }
            </div>
        </List.Item>
    )
});

const FeedbackController = ({goback, navpush}) => {

    const onPreview = (event, item) => {
        event.stopPropagation();
        navpush('./preview', false, item)
    }

    const [stateCode, setStateCode] = useState(3);
    const [dataSource, setDataSource] = useState([]);
    const requestData = () => {
        FeedbackResortList().then(response => {
            const data = response.data || []
            setStateCode(data.length >0 ? -1 : 1)
            setDataSource(data)
        }).catch(()=> {
            setStateCode(1)
        })
    }

    useEffect(() => {
        requestData()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    
    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback} right={
                    <div>
                        <div
                            onClick={()=> {navpush('./resort')}}
                            style={{
                                width : 'auto', 
                                float : 'right', 
                                padding : '6px 12px',
                                fontSize : '15px'
                            }}
                        >Resort</div>
                    </div>
                    }>Feedback</NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <ListView>
                    <CellStateView stateType={stateCode} onRefresh={()=>{requestData()}}/> 
                    {
                        dataSource.map((item, index) => (
                            <ItemView 
                                onClick={()=> {navpush('./list', false, item)}} 
                                onPreview={(event)=>{onPreview(event, item)}} 
                                item={item}
                                key={index}
                            />
                        ))
                    }
                </ListView>
            </BodyView>
        </>
    );
}
export default React.memo(FeedbackController)